import { EVENTS } from 'modules/Analytics/consts';
import AnalyticsService from 'modules/Analytics/service';
import { SEGMENT_TO_DISPLAY_NAME_MAP } from 'modules/Ordering';

export const addSurveillanceEvent = (
  action: string,
  source: string,
  scrips: Record<string, string[]> | null,
) => {
  if (!scrips || !Object.keys(scrips).length || !action || !source) {
    return;
  }
  AnalyticsService.sendEvent(
    EVENTS.SECURITY_UNDER_SURVEILLANCE,
    {
      Action: action,
      Source: source,
      Scrips: scrips,
    },
    true,
  );
};

export const addSingleScripSurveillanceEvent = (
  scrip: DataSchema | null,
  accepted: boolean | undefined,
  source: string,
) => {
  if (!scrip) {
    return;
  }
  const segment = scrip?.segment;
  const scripSymbol = scrip?.symbol;
  const segmentDisplayName = segment
    ? SEGMENT_TO_DISPLAY_NAME_MAP[segment]
    : segment;

  let scrips = null;
  if (segmentDisplayName && scripSymbol) {
    scrips = {
      [segmentDisplayName]: [scripSymbol],
    };
  }
  if (accepted) {
    addSurveillanceEvent('Order anyway', source, scrips);
  } else {
    addSurveillanceEvent('Cancel', source, scrips);
  }
};
